import {FieldTypeName} from "../../../models/filter/filter.field.type.name";
import {FieldGroupConfig} from "../../../models/filter/filter.group";

export const filtersFactory = (): FieldGroupConfig[] => {
    return [
        {
            visibleName: 'ID',
            name: 'id',
            fields: [
                {
                    type: FieldTypeName.STRING,
                    name: 'id'
                }
            ]
        }
    ]
}